import analytics from "../analytics/analytics.js";
import fetchWithTimeout from "../utils/fetchWithTimeout.js";
const SUMMARY_URL = '/genai-svc/genai/chat/hotelSummary';
async function fetchRequest({ prompts, hotelDetail, source, fetchRequestOptions }) {
    const currentSummary = this;
    try {
        const res = await fetchWithTimeout(SUMMARY_URL, {
            method: 'POST',
            body: JSON.stringify({
                prompts,
                hotelDetail,
                productId: 5,
                source
            }),
            headers: {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
                'Content-Encoding': 'identity',
                ...fetchRequestOptions?.headers
            }
        }, 10000);
        const fullSummaryWords = [];
        if (200 !== res.status) throw new Error(`Unexpected status code: ${res.status} - ${res.statusText || 'No status text'}`);
        if (!res.body || 'function' != typeof res.body.getReader) throw new Error('Response body is not readable');
        const reader = res.body.getReader();
        reader.read().then(async function processStream({ done, value: u8ArrValue }) {
            if (done) {
                const text = fullSummaryWords.join('');
                currentSummary.status = 'DONE';
                currentSummary.text = text;
                return;
            }
            if (u8ArrValue) {
                const value = u8ArrValue.filter((x)=>0 !== x);
                const response = new Response(value);
                const textRes = await response.text();
                fullSummaryWords.push(textRes);
                if (fullSummaryWords?.join('')) currentSummary.text = fullSummaryWords.join('');
            }
            return reader.read().then(processStream);
        }).catch((err)=>{
            analytics.logError({
                message: 'Failed to parse hotel summary stream',
                error: err.message,
                stack: err.stack,
                loggedFrom: 'generateHotelSummary'
            });
            currentSummary.error = err.message;
            currentSummary.status = 'ERROR';
            currentSummary.text = '';
        });
    } catch (err) {
        analytics.logError({
            message: 'Failed to fetch hotel summary response',
            error: err.message,
            stack: err.stack,
            loggedFrom: 'generateHotelSummary'
        });
        currentSummary.error = err.message;
        currentSummary.status = 'ERROR';
        currentSummary.text = '';
    }
}
const hotelSummaryManagerinit = ()=>{
    const summaryStore = new Map();
    return {
        addHotelSummary: (hotelName, options)=>{
            if (summaryStore.has(hotelName)) return;
            const summaryInstance = {
                error: '',
                status: 'PENDING',
                text: '',
                fetchRequest
            };
            summaryStore.set(hotelName, summaryInstance);
            summaryInstance.fetchRequest(options).catch((err)=>{
                analytics.logError({
                    message: 'fetch request failed',
                    error: err.message,
                    stack: err.stack,
                    loggedFrom: 'generateHotelSummary'
                });
            });
        },
        getHotelSummary: (hotelName)=>summaryStore.get(hotelName)
    };
};
const hotelSummaryManager = hotelSummaryManagerinit();
export { hotelSummaryManager };
